import { mapLocationToString, mapStringToLocation } from "@/hooks";
import { editProfileSchema, EditProfileSchemaModel } from "../types/schema";
import { useSelector } from "react-redux";
import { RootState } from "@/store/reducers";
import { useDispatch } from "react-redux";
import {
  Form,
  InputField,
  SelectField,
  UploadImageField,
} from "@/components/Form";
import {
  Button,
  EditIc,
  Image,
  MailIc,
  PhoneIc,
  UserIc,
} from "@/components/Elements";
import { Location, LocationMapView } from "@/features/misc/components";
import { updateUserDetail, useUpdateProfileMutation } from "@/features/auth";

export const ViewProfileScreen = () => {
  const [updateProfile] = useUpdateProfileMutation();
  const { distanceOptions, userDetail } = useSelector(
    (state: RootState) => state.login
  );
  const dispatch = useDispatch();

  async function handleRegister({ location, ...rest }: any) {
    const payload = {
      ...rest,
      location: mapLocationToString(location),
    };
    await updateProfile(payload);
    dispatch(updateUserDetail(payload));
  }

  return (
    <>
      <Form<EditProfileSchemaModel, typeof editProfileSchema>
        onSubmit={async (values) => {
          handleRegister(values);
        }}
        schema={editProfileSchema}
        options={{
          defaultValues: {
            ...userDetail,
            location: mapStringToLocation(userDetail?.location),
          },
        }}
        className="p-5"
      >
        {(props) => {
          const {
            register,
            handleSubmit,
            setValue,
            formState,
            getValues,
            watch,
          } = props;
          const { profileImage, profileImageUrl, distanceRadius, location } =
            getValues();
          watch("profileImage");
          return (
            <>
              <div className="mt-[30px] mb-[20px] flex items-center justify-center">
                <UploadImageField name="profileImage" setValue={setValue}>
                  <div className="border border-[#d3d3d3] rounded-[50px] w-[100px] h-[100px] p-[5px] relative">
                    <Image
                      fileDataAsBase64={profileImage?.fileDataAsBase64}
                      src={profileImageUrl}
                      isApiUrl={!!profileImageUrl}
                      className="self-center w-full h-full rounded-[50px]"
                    />
                    <div className="absolute bottom-0 right-0 z-10">
                      <EditIc className="w-6 h-6 text-[#969fa4]" />
                    </div>
                  </div>
                </UploadImageField>
              </div>
              <InputField
                type="text"
                placeholder="First Name"
                label="First Name"
                registration={register("firstName")}
                error={formState.errors["firstName"]}
                icon={<UserIc className="h-6 w-6" />}
              />
              <InputField
                type="text"
                placeholder="Last Name"
                label="Last Name"
                registration={register("lastName")}
                error={formState.errors["lastName"]}
                icon={<UserIc className="h-6 w-6" />}
              />
              <InputField
                type="text"
                placeholder="Email Address"
                label="Email Address"
                registration={register("email")}
                error={formState.errors["email"]}
                icon={<MailIc className="h-6 w-6" />}
              />
              <Location {...props} />
              <InputField
                type="text"
                placeholder="Phone"
                label="Phone"
                registration={register("mobile")}
                icon={<PhoneIc className="h-6 w-6" />}
              />
              <SelectField
                registration={register("distanceRadius")}
                className="text-[20px]"
                label="Radius"
                options={distanceOptions}
              />
              <div className="flex justify-between mt-5">
                {location && distanceRadius && (
                  <LocationMapView
                    location={location}
                    radius={distanceRadius}
                  />
                )}
                <Button
                  onClick={handleSubmit(handleRegister)}
                  className="w-[45%]"
                >
                  Update Profile
                </Button>
              </div>
            </>
          );
        }}
      </Form>
    </>
  );
};
